import {
    PCS_REQUEST_GET,
    PCS_RESPONSE_GET_SUCCESS,
    PCS_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/pcsConstants";
  
  export const pcsShReducer = (state = { pcs: {} }, action) => {
    switch (action.type) {
      case PCS_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case PCS_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          pcs: action.payload,
        };
      case PCS_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  